var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10mm",
    height: "10mm",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.324 -57.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.197,
    y: 57.819,
    width: 7.8263,
    height: 8.0025,
    fill: "#333",
    strokeWidth: 0.32876
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.324 57.17 2 2v6l-2 2z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.324 57.174-2 1.9959h-6l-1.9985-1.9959z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.324 67.17-2-2v-6l2-1.9959z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.324 67.17 2-2h6l2 2z",
    fill: "#4d4d4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.88a59fedff617406e0af55706288ef85.svg";
export { ForwardRef as ReactComponent };